export default __webpack_public_path__ + "static/media/coupon-item-ddf.10bb521c.png";